// extracted by mini-css-extract-plugin
module.exports = {"question":"Question_question__2oG9X","title":"Question_title__I14UB","message":"Question_message__2-7Rb","block":"Question_block__3i0HO","content":"Question_content__1o1QR"};